var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftres"},[_c('div',{staticClass:"homePage-top"},[_c('ReportGuide'),_c('CommonQuestions')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }